import LinkPreview from "../LinkPreview/LinkPreview";

import styles from "./Form.module.css";

const CurrentInfo = ({
  currentStep,
  pageData,
  deleteLink,
  deleteScript,
  isEditing,
}) => {
  if (currentStep === 1 && isEditing) {
    return (
      <div className={styles.information_container}>
        <p>
          <strong>Título:</strong> {pageData.title}
        </p>
        <p>
          <strong>Descrição:</strong> {pageData.description}
        </p>
      </div>
    );
  }

  if (currentStep === 3 && isEditing) {
    return (
      <div className="mb-5 mt-5">
        <div className="centerr">
          <h2>Estilo Atual</h2>
        </div>
        <div className="centerr">
          <LinkPreview
            hoverBgColor={pageData.style.hoverBgColor}
            bgColor={pageData.style.bgColor}
            fontColor={pageData.style.fontColor}
            borderStyle={pageData.style.borderStyle}
            hoverFontColor={pageData.style.hoverFontColor}
            name="Exemplo"
            Link="site.com"
          />
        </div>
      </div>
    );
  }

  if (currentStep === 4) {
    return (
      <div className="center_column">
        <h2>Links</h2>
        {pageData.pageLinks.map((link) => (
          <LinkPreview
            currentLinkId={link.id}
            deleteLink={deleteLink}
            isEditing={true}
            key={link.id}
            hoverBgColor={pageData.style.hoverBgColor}
            bgColor={pageData.style.bgColor}
            fontColor={pageData.style.fontColor}
            borderStyle={pageData.style.borderStyle}
            hoverFontColor={pageData.style.hoverFontColor}
            name={link.title}
            Link="site.com"
          />
        ))}
      </div>
    );
  }

  if (currentStep === 5) {
    return (
      <div className="center_column">
        <h2>Scripts</h2>
        {pageData.pageScripts.map((script) => (
          <LinkPreview
            currentLinkId={script.id}
            deleteLink={deleteScript}
            isEditing={true}
            key={script.id}
            hoverBgColor={pageData.style.hoverBgColor}
            bgColor={pageData.style.bgColor}
            fontColor={pageData.style.fontColor}
            borderStyle={pageData.style.borderStyle}
            hoverFontColor={pageData.style.hoverFontColor}
            name={script.title}
            Link="site.com"
          />
        ))}
      </div>
    );
  }
};

export default CurrentInfo;
